<template>
  <scoped>
    <label
      v-if="title"
      :for="id"
    >
      {{ title }}
    </label>
    <input
      :id="id"
      v-model="value"
      :max="max"
      :min="min"
      type="number"
      :disabled="readOnly"
      @change="validate()"
    >
  </scoped>
</template>

<script setup lang="ts">
  import {useId} from "vue"

  const props = defineProps({
    max: {
      default: null,
      required: false,
      type: Number
    },
    min: {
      default: null,
      required: false,
      type: Number
    },
    readOnly: {
      default: false,
      required: false,
      type: Boolean
    },
    title: {
      default: null,
      required: false,
      type: String
    }
  })
  const id = useId()
  const value = defineModel("value", {
    default: null,
    required: true,
    type: Number
  })

  function validate() {
    if (props.min && value.value < props.min) {
      value.value = props.min
    }
    if (props.max && value.value > props.max) {
      value.value = props.max
    }
  }
</script>

<style scoped>
  input[type = "number"] {
    background-color: var(--color-white);
    border-color: var(--theme-color-primary);
    border-radius: var(--border-radius-small);
    border-style: solid;
    border-width: var(--border-width-light);
    display: block;
    margin: 0.5em 0;
    padding: 0.5em;

    &:focus, &:hover {
      border-color: var(--color-grey);
    }
  }

  label {
    display: block;
    font-weight: bolder;
  }
</style>
